export const handleRoleButtons = () => {
  const roleButtons = document.querySelectorAll(
    'div[role="button"]',
  ) as NodeListOf<HTMLDivElement>;
  for (const roleButton of roleButtons) {
    roleButton.addEventListener("keydown", function (e: any) {
      const keyD = e.key !== undefined ? e.key : e.keyCode;

      if (
        keyD === "Enter" ||
        keyD === 13 ||
        ["Spacebar", " "].indexOf(keyD) >= 0 ||
        keyD === 32
      ) {
        e.preventDefault();
        roleButton.click();
      }
    });
  }
};
